'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateUniqueErrorId = undefined;

var _timestamp = require('../uid/timestamp');

var _randomString = require('../uid/randomString');

var _randomString2 = _interopRequireDefault(_randomString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateUniqueErrorId = exports.generateUniqueErrorId = function generateUniqueErrorId() {
  return (0, _timestamp.createTimestamp)(new Date()) + (0, _randomString2.default)(3);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/error/errorUtil.js
// module id = 2271
// module chunks = 0